export function makeDatestampObject(year, month, day) {
  return {
    year,
    month,
    day
  };
}
export function makeDatestampArray(year, month, day) {
  return [year, month, day];
}